import * as angular from "angular";
import {CacheService} from "./services/CacheService";
import {TeamCacheProxy} from "./services/TeamCacheProxy";
import {Observable} from "rxjs";
import {CachingTimesProvider, ICachingTimesService} from "./providers/CachingTimesProvider";
import {UserCacheProxy} from "./services/UserCacheProxy";
import {LocalForageProvider} from "./providers/LocalForageProvider";

export let ngCache:angular.IModule = angular.module("ngCache", [
    "ngLeague"
]);

ngCache.service("CacheService", CacheService);
ngCache.service("TeamCacheProxy", TeamCacheProxy);
ngCache.service("UserCacheProxy", UserCacheProxy);
ngCache.provider("CachingTimes", CachingTimesProvider.instance);
ngCache.provider("LocalForage", LocalForageProvider.instance);

ngCache.config(["$httpProvider", "$compileProvider", (
    $httpProvider:angular.IHttpProvider,
    $compileProvider:angular.ICompileProvider
) => {
    $httpProvider.useApplyAsync(true);
    $compileProvider.debugInfoEnabled(false);
}]);

ngCache.config(["LocalForageProvider", function(LocalForageProvider) {
    LocalForageProvider.localForage.config({
        driver: LocalForageProvider.localForage.LOCALSTORAGE,
        name: "ngCache",
        version: 1.0,
        storeName: "ngCache",
        description: "ngCache"
    });

    LocalForageProvider.localForage.newObservable.factory = function (subscribeFn) {
        return Observable.create(subscribeFn);
    };
}]);

ngCache.run(["$interval", "CachingTimes", "CacheService", (
    $interval:angular.IIntervalService,
    CachingTimes: ICachingTimesService,
    CacheService: CacheService
) => {
    CacheService.cleanUp();

    $interval(() => {
        CacheService.cleanUp();
    }, CachingTimes.getCleanUpInterval(), 0, false);
}]);

export * from "./services/CacheService";
export * from "./services/TeamCacheProxy";
export * from "./providers/CachingTimesProvider";
export * from "./services/UserCacheProxy";
export * from "./providers/LocalForageProvider";